import React from "react";

const FAQ = () => {
  return (
    <section className="bg-white dark:bg-gray-900 mt-16 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-center text-gray-900 dark:text-white mb-10">
          FAQ’s
        </h1>

        <div className="space-y-6">
          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q1: What is Kriptees?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Kriptees is an online retailer offering high-quality, affordable anime-inspired
              streetwear, including T-shirts, hoodies, and sweatshirts for anime enthusiasts.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q2: What products does Kriptees offer?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Kriptees specializes in anime-themed apparel such as T-shirts, hoodies, and
              sweatshirts, featuring designs inspired by popular anime series.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q3: Does Kriptees offer customization options?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Yes, Kriptees provides custom apparel services, allowing customers to
              create personalized designs on various clothing items.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q4: What are the shipping options available?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Kriptees offers pan-India shipping, ensuring delivery across the country.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q5: What is Kriptees’ return and exchange policy?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Kriptees offers a 7-day easy return and exchange policy with no questions asked.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q6: How can I contact Kriptees for further assistance?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: You can reach out to Kriptees through their Contact Us page on the website.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q7: Are Kriptees products made in India?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: Yes, Kriptees is a 100% homegrown brand, and all products are made in India.
            </p>
          </div>

          <div className="border-b pb-4">
            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              Q8: How can I stay updated on new arrivals and promotions?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              A: To stay informed about the latest products and offers, follow Kriptees on
              their official Instagram account: @kriptees_official.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
